import React, { useState, useEffect } from 'react';
import { Snackbar, Box, Typography, Button, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BORDER_COLORS } from '../../utils/colors';
import { gtmUpdateConsent } from '../../utils/gtm';

const COOKIE_CONSENT_KEY = 'cookie_consent_accepted';

const CookieBanner: React.FC = () => {
  const { t } = useTranslation('home');
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasConsent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!hasConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
    gtmUpdateConsent();
    setIsVisible(false);
  };

  return (
    <Snackbar
      open={isVisible}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        '& .MuiSnackbarContent-root': {
          background: 'transparent',
          padding: 0,
          boxShadow: 'none',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 2, md: 3 },
          flexWrap: { xs: 'wrap', sm: 'nowrap' },
          p: { xs: 2, md: 3 },
          background: 'rgba(20, 20, 20, 0.95)',
          backdropFilter: 'blur(20px)',
          border: `1px solid ${BORDER_COLORS.DEFAULT}`,
          borderRadius: 3,
          maxWidth: '900px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.5)',
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', fontSize: { xs: '0.8rem', md: '0.9rem' } }}
          >
            {t('cookies.text')}{' '}
            <MuiLink
              component={Link}
              to="/privacy"
              sx={{
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              {t('cookies.learnMore')}
            </MuiLink>
          </Typography>
        </Box>
        <Button
          variant="contained"
          onClick={handleAccept}
          sx={{
            flexShrink: 0,
            px: 4,
            py: 1,
            borderRadius: '8px',
            background: 'rgba(185, 28, 28, 0.15)',
            border: '1px solid rgba(185, 28, 28, 0.5)',
            color: '#fff',
            backdropFilter: 'blur(10px)',
            fontWeight: 600,
            transition: 'all 0.3s ease',
            '&:hover': {
              background: 'rgba(185, 28, 28, 0.3)',
              borderColor: '#dc2626',
              boxShadow: '0 0 20px rgba(185, 28, 28, 0.4)',
            },
          }}
        >
          {t('cookies.accept')}
        </Button>
      </Box>
    </Snackbar>
  );
};

export default CookieBanner;
